import { Controller } from "@hotwired/stimulus"

// Byerne på en udsendelse følger området, så de to filtre ikke kan pege hver
// sin vej: Midt viser kun Midts byer, Udenfor Roskilde viser ingen, og Alle
// områder viser dem alle. Reglen bag står på Broadcast (town_lies_in_zone);
// det her er bare, at skærmen ikke tilbyder et valg, der bliver afvist.
//
// Listen bygges op igen fra en kopi i stedet for at skjule de byer, der ikke
// hører til. Safari ser bort fra hidden og display: none på en <option>, så
// de skjulte byer ville stå der alligevel.
//
// Byselect'en er grupperet efter område (optgroup-mærket er områdets navn,
// "Midt"), og områdets værdi er slug'en ("midt"). Byer uden område står uden
// for grupperne. Forsvinder den valgte by, sendes en change videre fra byen,
// så modtagerlisten hentes igen med den rensede by.
export default class extends Controller {
  static targets = ["area", "town"]

  connect() {
    this.options = Array.from(this.townTarget.children).map((node) => node.cloneNode(true))
    this.filter()
  }

  filter() {
    const area = this.areaTarget.value
    const chosen = this.townTarget.value
    const name = area.charAt(0).toUpperCase() + area.slice(1)

    const keep = this.options.filter((node) => {
      if (node.tagName === "OPTION" && node.value === "") return true
      if (area === "") return true
      if (area === "udenfor") return false
      return node.tagName === "OPTGROUP" && node.label === name
    })

    this.townTarget.replaceChildren(...keep.map((node) => node.cloneNode(true)))
    this.townTarget.disabled = area === "udenfor"

    const stillThere = Array.from(this.townTarget.options).some((option) => option.value === chosen)
    this.townTarget.value = stillThere ? chosen : ""

    if (chosen !== "" && !stillThere) {
      this.townTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
